module.exports = __webpack_public_path__ + "9ce7fca33932cbf97a7fddf5218840b2.png";